import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';

import { Home20Regular } from '@fluentui/react-icons';
import { BookInformation20Regular } from '@fluentui/react-icons';
import { Folder20Regular, PersonAdd20Regular, Link20Regular,  Phone20Regular } from '@fluentui/react-icons';
import { ME } from '../../graphql/queries';

const MiniMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  marginRight: 10,
`;

const MiniMenuItem = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  color: #fff;

  &:hover {
    background-color:rgb(255, 255, 255);
    color: #0078d4;
  }

  svg {
    width: 20px;
    height: 20px;
    fill: #0078d4;
  }
`;


export const MiniMenuIcons = () => {
  const navigate = useNavigate();
  const { data, loading } = useQuery(ME);
  const user = data?.me;

  const hasAccess = user
    ? ['admin', 'superadmin'].includes(user.role) ||
      (user.accessExpiry && new Date(user.accessExpiry) > new Date())
    : false;

  const forAdmins = user
    ? ['admin', 'superadmin'].includes(user.role) 
    : false;

  if (loading) return null; 

return (
  <MiniMenuContainer>
    <MiniMenuItem title="" onClick={() => navigate('/Home')}>
      <Home20Regular />
    </MiniMenuItem>
    <MiniMenuItem title="" onClick={() => navigate('/Blog')}>
      <BookInformation20Regular />
    </MiniMenuItem>
    {/*<MiniMenuItem title="" onClick={() => navigate('/Instructions')}>
      <Phone20Regular />
    </MiniMenuItem> */}
    <MiniMenuItem title="" onClick={() => navigate('/Dist')}>
      <Folder20Regular />
    </MiniMenuItem>
    {/*hasAccess && (
              <MiniMenuItem title="" onClick={() => navigate('/Svor')}>
                <Link20Regular />
              </MiniMenuItem>
    )*/}
    {forAdmins && (
              <MiniMenuItem title="" onClick={() => navigate('/Administration')}>
                <PersonAdd20Regular />
              </MiniMenuItem>
    )}
  </MiniMenuContainer>
  )
};